export default __webpack_public_path__ + "static/bncff-mobile-2-mobile-6950c541c49e7d58ebc330b85065bc4b.jpg";